import {ApiDeviceGroupResponseDto} from '@birco/rainmesh-api';
import { ApiFilters } from '../../../../core/models/interfaces/api-filters.interface';

export const FEATURE_NAME = 'deviceGroupState';

export interface DeviceGroupState {
  entities: Record<string, ApiDeviceGroupResponseDto>;
  expandedById: Record<string, boolean>;
  error: any | null;
  isLoading: boolean;
  filter: DeviceGroupFilter;
  pages: Record<number, string[]>;
  totalCount: number;
}

export interface DeviceGroupFilter extends ApiFilters {
  deviceId?: string;
}

export const initialState: DeviceGroupState = {
  entities: {},
  expandedById: {},
  filter: {
    page: 0,
    pageSize: 12,
    deviceId: undefined,
  },
  pages: {},
  totalCount: 0,
  isLoading: false,
  error: null,
};
